import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const ICT = (props) => {
  const { height, width, fill, className } = props;
  return (
    <svg
      id="ict"
      width={width}
      height={height}
      fill={fill}
      stroke="none"
      className={className}
      viewBox="0 0 25 25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M16.1379 13.8074L18.138 14.2043C18.1587 15.1854 18.9708 15.9639 19.9519 15.9432C20.9329 15.9225 21.7115 15.1103 21.6908 14.1293C21.67 13.1482 20.8579 12.3697 19.8768 12.3904C19.1879 12.405 18.5694 12.8166 18.2901 13.4466L16.2381 13.0394C16.236 12.2885 15.9437 11.5674 15.4224 11.0269L18.0784 7.27495C19.1986 7.80762 20.5386 7.33127 21.0712 6.21101C21.6039 5.09075 21.1276 3.75082 20.0073 3.21815C18.887 2.68548 17.5471 3.16183 17.0144 4.28209C16.6078 5.13727 16.7812 6.15556 17.4479 6.82797L14.8176 10.5437C13.608 9.81716 12.0517 10.0613 11.1226 11.1233L7.66943 8.44153C8.12269 7.56906 7.78289 6.4943 6.91041 6.04104C6.03794 5.58778 4.96318 5.92758 4.50992 6.80005C4.05666 7.67252 4.39646 8.74728 5.26893 9.20054C5.88198 9.51904 6.62394 9.45412 7.17231 9.034L10.692 11.7674C10.1072 12.9623 10.4053 14.4015 11.4166 15.2657L9.27753 18.29C8.1451 17.6028 6.66992 17.9637 5.98269 19.0962C5.29545 20.2286 5.65636 21.7038 6.78884 22.391C7.92127 23.0783 9.39645 22.7174 10.0837 21.5849C10.6178 20.7048 10.5307 19.582 9.8672 18.7948L12.064 15.6881C12.8155 16.0454 13.6839 16.0649 14.4507 15.7416L17.0572 19.592C16.2906 20.4025 16.3262 21.681 17.1367 22.4476C17.9472 23.2142 19.2257 23.1786 19.9923 22.3681C20.7589 21.5576 20.7233 20.2791 19.9128 19.5125C19.3152 18.9473 18.4345 18.8009 17.6861 19.1425L15.1172 15.3475C15.6147 14.9577 15.9728 14.4175 16.1379 13.8074Z" />
    </svg>
  );
};
/* eslint-enable max-len */

ICT.defaultProps = {
  className: null,
};

ICT.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default ICT;
